/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Schedule } from '@src/app/model/schedule';
import { IFormAction, ActionColor } from '@src/app/shared/form/form.component';

/** Portions on a custom schedule are entered by hand or imported, and nothing can derive them
 * again - so they are read only until deliberately unlocked. Every other charge type calculates
 * its portions, and this is not offered.
 */
export class EditPortionsAction implements IFormAction {
    name = $localize`Edit Portions`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'lock_open';
    approvalNeeded = false;
    disabled = false;
    approvalText = '';
    tipText = $localize`Unlock the portions on this custom schedule so they can be edited`;

    constructor(private enablePortions: () => void) { }

    action() {
        this.enablePortions();
        return null;
    }

    setup(schedule: Schedule) {
        this.show = !!schedule?.id && schedule?.chargeTypeId === Schedule.chargeId.custom;
    }
}
